/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat.js';
import Decimal from 'decimal.js';
dayjs().format(); // 导入插件
dayjs.extend(CustomParseFormat); // 使用插件
/**
 * 下划线转成驼峰
 * @param name 输入值
 * @returns
 */
// eslint-disable-next-line no-useless-escape
const toHump = (name) => name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
/**
 * 驼峰转成下划线
 * @param name 输入值
 * @returns
 */
const toLine = (name) => name.replace(/\B([A-Z])/g, '_$1').toLowerCase();
/**
 * 日期 string 转成 Date 格式
 * @param date 日期字符串
 * @returns
 */
const str2Date = (date) => {
    const dayObj = dayjs(date);
    if (dayObj.isValid()) {
        return dayObj.toDate();
    }
};
const date2TimestampStr = (date, format) => {
    if (!format || format === 's') {
        return String(Number.parseInt(String(date.getTime() / 1000), 10));
    }
    return String(date.getTime());
};
/**
 * 8进制转成16进制
 * @param str 转换字符串
 * @returns
 */
const utf8to16 = (str) => {
    let out = '';
    let i = 0;
    const len = str.length;
    let c;
    let char2;
    let char3;
    while (i < len) {
        c = str.charCodeAt(i++);
        switch (c >> 4) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += str.charAt(i - 1);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = str.charCodeAt(i++);
                out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = str.charCodeAt(i++);
                char3 = str.charCodeAt(i++);
                out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
                break;
        }
    }
    return out;
};
/**
 * 对象转成query形式的字符串
 * @param obj 转换对象
 * @returns
 */
const queryParams = (obj) => {
    if (obj) {
        let query = '';
        for (const [key, value] of Object.entries(obj)) {
            let val = value;
            if (Array.isArray(value)) {
                val = value.join(',');
            }
            query += `&${key}=${val}`;
        }
        query = query.replace('&', '?');
        return query;
    }
    return '';
};
/** 金额由分位改为元，服务器返回的金额单位通常为分 */
const fen2Yuan = (num) => new Decimal(num).dividedBy(100)
    .toFixed(2);
/** 金额由元改为分，发送发给服务器前需要处理 */
const yuan2fen = (num) => new Decimal(num).mul(100)
    .toFixed(0);
export { toHump, toLine, str2Date, date2TimestampStr, utf8to16, queryParams, fen2Yuan, yuan2fen };
